import { UnshadowedElement, html } from "../lib/unshadowed.js";

/** Basic revealable text block */
export class TextRevealer extends UnshadowedElement {
    static elementName() { return "text-revealer" }

    static properties = {
        cutoff: { type: Number },
        text: { type: String },
        expanded: { type: Boolean },
    }

    constructor() {
        super();
        // Defaults
        this.cutoff = 140;
        this.text = "";
    }

    readMore() {
        this.expanded = true;
    }

    render() {
        if (this.expanded || this.text.length < this.cutoff) {
            return html`${this.text}`;
        } else {
            const searcharea = this.text.substring(0, this.cutoff - 5);
            // Find whitespace before the cutoff
            const regex = /\s(?=[^\s]*$)/g;
            regex.test(searcharea);
            const spaceIdx = regex.lastIndex;
            // Include the hidden text for SEO. No whitespace in case we're in pre-wrap
            return html`<span>${this.text.substring(0, spaceIdx)}</span><span class="hide-visually">${this.text.substring(spaceIdx)}</span><span>...</span><button @click=${this.readMore}>Read More</button>`;
        }
    }
}
